import { bypassCORS } from "../global";

// XXX_INTERNAL - allows to connect directly to another docker container. Will not work with Client Side Render !!!
// XXX_EXTERNAL - allows to connect to endpoint via domain. Will work both with SSR (avoid using) and CSR.
// XXX_NODE     - connects to node endpoint and exists only for frontend purposes.

export const API_PAYMENT_INTERNAL = process.env.NEXT_PUBLIC_API_PAYMENT_INTERNAL;
export const API_PAYMENT_EXTERNAL = process.env.NEXT_PUBLIC_API_PAYMENT_EXTERNAL;

export const API_SUBSCRIPTION_PAYMENT_EXTERNAL = bypassCORS(`${API_PAYMENT_EXTERNAL}/plans/`);

export const API_REPEAT_PAYMENT_EXTERNAL = bypassCORS(`${API_PAYMENT_EXTERNAL}/install/pay/`);

export const API_RESUME_DEPLOYMENT_EXTERNAL = bypassCORS(`${API_PAYMENT_EXTERNAL}/install/start_status_resume/`);